module.exports = __webpack_public_path__ + "media/icons/facebook_icon_normal-b8ef6b0b.svg";